class ProductStickyPanel extends HTMLElement {
  constructor() {
    super();
    this.variants = [];
    this.defaultImageAttrs = { src: '', srcset: '' };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const dataEl = this.querySelector('script[data-sticky-panel-variants]');
    if (dataEl) {
      try {
        this.variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.error('Error parsing sticky panel variants', e);
      }
    }
    
    const rawDefaultUrl = this.dataset.defaultImage;
    this.defaultImageAttrs = this.buildImageAttrs(rawDefaultUrl);

    this.addEventListener('change', this.onChange.bind(this));
  }

  imageForId(id) {
    for (let i = 0; i < this.variants.length; i++) {
      if (this.variants[i].id === id) return this.variants[i].image;
    }
    return null;
  }

  buildImageAttrs(rawUrl) {
    if (!rawUrl) return { src: '', srcset: '' };
    const base = rawUrl.replace(/([?&])width=\d+/g, '');
    const sep = base.indexOf('?') === -1 ? '?' : '&';
    return {
      src: base + sep + 'width=96',
      srcset: base + sep + 'width=48 48w, ' + base + sep + 'width=96 96w'
    };
  }

  setVariantImage(url) {
    const wrapper = document.querySelector('[data-variant-image-wrapper]');
    if (!wrapper || !url) return;
    let img = wrapper.querySelector('img');
    const attrs = this.buildImageAttrs(url);
    if (img) {
      img.src = attrs.src;
      img.srcset = attrs.srcset;
    } else {
      img = document.createElement('img');
      img.width = 48;
      img.height = 80;
      img.loading = 'eager';
      img.setAttribute('sizes', '48px');
      img.setAttribute('fetchpriority', 'high');
      wrapper.appendChild(img);
      img.src = attrs.src;
      img.srcset = attrs.srcset;
    }
  }

  setDefaultImage() {
    const wrapper = document.querySelector('[data-variant-image-wrapper]');
    if (!wrapper) return;
    let img = wrapper.querySelector('img');
    
    if (img) {
      img.src = this.defaultImageAttrs.src;
      img.srcset = this.defaultImageAttrs.srcset;
    } else {
      img = document.createElement('img');
      img.width = 48;
      img.height = 80;
      img.loading = 'eager';
      img.setAttribute('sizes', '48px');
      img.setAttribute('fetchpriority', 'high');
      wrapper.appendChild(img);
      img.src = this.defaultImageAttrs.src;
      img.srcset = this.defaultImageAttrs.srcset;
    }
  }

  onChange(event) {
    const input = event.target;
    if (input.name !== 'id') return;

    // Update price in button
    const label = this.querySelector(`label[for="${input.id}"]`);
    if (label) {
      const price = label.getAttribute('data-price');
      if (price) {
        const priceEls = this.querySelectorAll('[data-product-price]');
        priceEls.forEach(el => el.textContent = price);
      }
    }

    // Update variant image if available
    const imageUrl = this.imageForId(parseInt(input.value, 10));
    if (imageUrl) {
      this.setVariantImage(imageUrl);
    } else {
      this.setDefaultImage();
    }
  }
}

if (!customElements.get('product-sticky-panel')) {
  customElements.define('product-sticky-panel', ProductStickyPanel);
}
